class TestimonialsSlide extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.section-testimonial-slider');
    if (!swiperEl) return;

    // Initialize Swiper
    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          480: { 
            slidesPerView: 1.2
          },
          768:  { 
            slidesPerView: 1.3, 
            spaceBetween: 50 
          },
          1024:  { 
            slidesPerView: 2, 
            spaceBetween: 50 
          }
        }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('testimonials-slide', TestimonialsSlide);